import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { FolderlinkApiService } from './api/folderlink-api.service';
import { FolderLink } from './user';

@Injectable({ providedIn: 'root' })
export class FolderlinkService {
  constructor(private api: FolderlinkApiService) {}

  getFolderlink(projectId: string): Observable<FolderLink> {
    return this.api
      .fetchSingle(projectId)
      .pipe(tap((folderLink: FolderLink) => folderLink));
  }
}
